import { tagAnatomy as parts } from "@chakra-ui/anatomy"
import type {
  PartsStyleInterpolation,
  PartsStyleObject,
  SystemStyleObject,
} from "@chakra-ui/theme-tools"
import { Badge } from "./badge"

const baseStyleContainer: SystemStyleObject = {
  ...Badge.baseStyle,
  lineHeight: 1,
  borderRadius: '0.25em',
}

const baseStyleLabel: SystemStyleObject = {
  lineHeight: 1,
  overflow: "visible",
}

const baseStyleCloseButton: SystemStyleObject = {
  fontSize: 'lg',
  w: "sm",
  h: "sm",
  transitionProperty: "common",
  transitionDuration: "normal",
  borderRadius: "full",
  marginStart: "0.375rem",
  marginEnd: "-1",
  opacity: 0.5,
  _disabled: {
    opacity: 0.4,
  },
  _focus: {
    boxShadow: 'none',
    bg: '',
  },
  _focusVisible: {
    boxShadow: "none",
    bg: "",
  },
  _hover: { opacity: 0.8 },
  _active: { opacity: 1 },
}

const baseStyle: PartsStyleObject<typeof parts> = {
  container: baseStyleContainer,
  label: baseStyleLabel,
  closeButton: baseStyleCloseButton,
}

const baseSizes: Record<string, PartsStyleObject<typeof parts>> = {

}

const variants: Record<string, PartsStyleInterpolation<typeof parts>> = {
  subtle: (props) => ({
    container: Badge.variants.subtle(props),
  }),
  solid: (props) => ({
    container: Badge.variants.solid(props),
  }),
  outline: (props) => ({
    container: Badge.variants.outline(props),
  }),
}

const defaultProps = {
  variant: "subtle",
  colorScheme: "primary",
}

export const Tag = {
  parts: parts.keys,
  variants,
  baseStyle,
  sizes: baseSizes,
  defaultProps,
}